// 调用登录接口
import { login, loginOut, getRoutes } from '@/api/login'
// 引入设置，清除cookies中的token
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const state = {
	token: getToken(), // 保存登录状态
	name: '',
	avatar: '',
	introduction: '',
	roles: [], // 路由角色权限
	buttons: [], // 按钮权限组
	role: '' // 角色权限
}

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_INTRODUCTION: (state, introduction) => {
		state.introduction = introduction
	},
	SET_NAME: (state, name) => {
		state.name = name
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles
	}, // 菜单权限方法
	SET_BUTTONS: (state, buttons) => {
		state.buttons = buttons
	}, // 按钮权限方法
	SET_ROLE: (state, role) => {
		state.role = role
	} // 角色权限方法
}

const actions = {
	// user login
	login({ commit }, userInfo) {
		const { username, password } = userInfo
		return new Promise((resolve, reject) => {
			login({ username: username.trim(), password: password })
				.then((response) => {
					const { data } = response
					commit('SET_TOKEN', data.token)
					setToken(data.token)
					resolve()
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	// 菜单权限
	setRoles({ commit }) {
		return new Promise((resolve, reject) => {
			commit('SET_ROLES', [
				'enterpriseCertification',
				'brandList',
				'qualificationsInfo',
				'qualifications',
				'assessmentDetails',
				'contractTemplate'
			])
			commit('SET_BUTTONS', [
				'/Enterprise/Auth/personAuthInfo',
				'/Enterprise/Auth/enterpriseAuthInfo',
				'/Enterprise/Auth/getAuthState',
				'/Brand/deleteBrand',
				'/Brand/editBrand',
				'/Brand/getBrandList',
				'/Brand/addBrand',
				'/Brand/getBrandData',
				'/Enterprise/Auth/enterpriseAuth',
				'/V2/Enterprise/Qualifications/addCertApp',
				'/User/getAssDetail',
				'/Contract/getShowContractTemplateList'
			])
			resolve([
				'enterpriseCertification',
				'brandList',
				'qualificationsInfo',
				'qualifications',
				'assessmentDetails',
				'contractTemplate'
			])
		})
	},
	// 按钮权限塞入
	setButtonsRole({ commit, state }, authName) {
		return new Promise((resolve, reject) => {
			if (state.buttons.indexOf(authName) !== -1) {
				return state.role
			} else {
				return ''
			}
		})
	},
	// 角色权限
	setRole({ commit }) {
		return new Promise((resolve, reject) => {})
	},
	// 按钮权限
	setButton({ commit }) {
		return new Promise((resolve, reject) => {})
	},

	// 退出登录
	logout({ commit, state, dispatch }) {
		return new Promise((resolve, reject) => {
			// 直接先前端登出再掉后端接口 解决后端登出接口加载过慢出现的bug
			commit('SET_TOKEN', '')
			commit('SET_ROLES', [])
			commit('SET_BUTTONS', [])
			commit('SET_ROLE', '')
			removeToken()
			resetRouter()
			dispatch('tagsView/delAllViews', null, { root: true })
			loginOut()
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},

	// 删除token
	resetToken({ commit }) {
		return new Promise((resolve) => {
			commit('SET_TOKEN', '')
			commit('SET_ROLES', [])
			commit('SET_BUTTONS', [])
			removeToken()
			resolve()
		})
	},
	// 重置路由
	async changeRoles({ commit, dispatch }, role) {
		resetRouter()
		const roles = await dispatch('setRoles', 1)
		const accessRoutes = await dispatch('permission/generateRoutes', roles, {
			root: true
		})
		router.addRoutes(accessRoutes)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
